module.exports = __webpack_public_path__ + "img/sameday_k.03dd7495.png";